/**
 * A booked visit's "Załączniki" (reason-section attachments) must show ONLY the
 * owner's documents — the ones the client attached when booking the visit, or
 * edited before the visit started. Clinic-side uploads (`uploadedByRole === 'STAFF'`,
 * i.e. a professional or organization admin) are clinical additions that belong in
 * the "Dokumenty" tab, not in the owner's reason section.
 *
 * Documents live in the standalone `documents` collection and carry `uploadedByRole`
 * ('OWNER' | 'STAFF'); the visit aggregation aliases them onto `visit.documents`.
 * Legacy rows predate the field, so a missing role is treated as OWNER — historically
 * those were owner booking uploads, and that's the safe fallback for this section.
 *
 * Use this everywhere a visit's "Załączniki" list is rendered, so the owner-only
 * rule can never be half-applied across the many such surfaces.
 */
export type WithUploadedByRole = {
  uploadedByRole?: 'OWNER' | 'STAFF' | null;
};

export function selectOwnerBookingDocuments<T extends WithUploadedByRole>(
  documents: readonly T[] | undefined | null,
): T[] {
  return (documents ?? []).filter(
    (doc) => (doc?.uploadedByRole ?? 'OWNER') === 'OWNER',
  );
}
